export default "/_next/static/images/effect-right-3-ce54bcc79b9a0c302ded383ae55ff6a8.svg";